import React from 'react';

interface Props {
  width?: string;
  height?: string;
}

const ComingSoonSVG: React.FC<Props> = ({ width, height }) => {
  return (
    <svg
      width={width ?? '67'}
      height={height ?? '9'}
      viewBox='0 0 40 6'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M4.19159 2.07182C4.19159 3.08287 3.51928 4.06077 2.04184 4.06077H1.33633V5.90055H0V0.0994472H2.04184C3.52758 0.0994472 4.19159 1.07735 4.19159 2.07182ZM2.78886 2.07182C2.78886 1.65746 2.55646 1.25967 1.94224 1.25967H1.33633V2.90055H1.94224C2.54816 2.90055 2.78886 2.49448 2.78886 2.07182Z'
        fill='#E7CDFF'
      />
      <path
        d='M8.8633 1.93923C8.8633 2.62707 8.53129 3.29006 7.70957 3.55525V3.5884L9.1123 5.89227H7.42737L6.52265 3.78729H6.06614V5.89227H4.72981V0.0994472H6.71355C8.19928 0.0994472 8.8633 1.01105 8.8633 1.93923ZM7.46057 1.96409C7.46057 1.59945 7.24476 1.25967 6.62225 1.25967H6.06614V2.6768H6.62225C7.23646 2.6768 7.46057 2.32044 7.46057 1.96409Z'
        fill='#E7CDFF'
      />
      <path
        d='M13.1688 5.90055H9.50014V0.0994472H13.0858V1.25967H10.8365V2.35359H12.6542V3.46409H10.8365V4.74033H13.1688V5.90055Z'
        fill='#E7CDFF'
      />
      <path
        d='M18.1902 0C19.7755 0 20.7715 1.22652 20.7715 3C20.7715 4.76519 19.7755 6 18.1902 6C16.5965 6 15.6005 4.76519 15.6005 3C15.6005 1.22652 16.5965 0 18.1902 0ZM18.1902 1.16022C17.4017 1.16022 17.0032 1.90608 17.0032 3C17.0032 4.09392 17.4017 4.83978 18.1902 4.83978C18.9704 4.83978 19.3688 4.09392 19.3688 3C19.3688 1.90608 18.9704 1.16022 18.1902 1.16022Z'
        fill='#E7CDFF'
      />
      <path
        d='M25.4886 1.93923C25.4886 2.62707 25.1566 3.29006 24.3349 3.55525V3.5884L25.7376 5.89227H24.0527L23.148 3.78729H22.6915V5.89227H21.3551V0.0994472H23.3389C24.8246 0.0994472 25.4886 1.01105 25.4886 1.93923ZM24.0859 1.96409C24.0859 1.59945 23.8701 1.25967 23.2476 1.25967H22.6915V2.6768H23.2476C23.8618 2.6768 24.0859 2.32044 24.0859 1.96409Z'
        fill='#E7CDFF'
      />
      <path
        d='M30.7736 3C30.7736 4.77348 29.7194 5.90055 28.1258 5.90055H26.1255V0.0994472H28.1258C29.7194 0.0994472 30.7736 1.22652 30.7736 3ZM29.3708 3C29.3708 1.87293 28.8313 1.25967 28.0511 1.25967H27.4618V4.74033H28.0511C28.8313 4.74033 29.3708 4.12707 29.3708 3Z'
        fill='#E7CDFF'
      />
      <path
        d='M35.0265 5.90055H31.3578V0.0994472H34.9435V1.25967H32.6942V2.35359H34.5119V3.46409H32.6942V4.74033H35.0265V5.90055Z'
        fill='#E7CDFF'
      />
      <path
        d='M39.751 1.93923C39.751 2.62707 39.419 3.29006 38.5973 3.55525V3.5884L40 5.89227H38.3151L37.4103 3.78729H36.9538V5.89227H35.6175V0.0994472H37.6012C39.087 0.0994472 39.751 1.01105 39.751 1.93923ZM38.3483 1.96409C38.3483 1.59945 38.1325 1.25967 37.5099 1.25967H36.9538V2.6768H37.5099C38.1242 2.6768 38.3483 2.32044 38.3483 1.96409Z'
        fill='#E7CDFF'
      />
    </svg>
  );
};

export default ComingSoonSVG;
